import {RefObject, useEffect, useRef, useState} from 'react';

export const useIsScrollable = <T extends HTMLElement>(): [RefObject<T>, boolean] => {
    const elementRef = useRef<T>(null);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const checkScrollable = () => {
            const element = elementRef.current;
            if (!element) {
                return;
            }

            const verticallyScrollable = element.scrollHeight > element.clientHeight;
            const horizontallyScrollable = element.scrollWidth > element.clientWidth;

            setIsScrollable(verticallyScrollable || horizontallyScrollable);
        };

        checkScrollable();

        const resizeObserver = new ResizeObserver(checkScrollable);
        if (elementRef.current) {
            resizeObserver.observe(elementRef.current);
        }

        const mutationObserver = new MutationObserver(checkScrollable);
        if (elementRef.current) {
            mutationObserver.observe(elementRef.current, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true,
            });
        }

        return () => {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, []);

    return [elementRef, isScrollable];
};
